module.exports = __webpack_public_path__ + "static/media/4.5a17082f.mp3";